<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="cadastro de hóspede"
          @close="dialog = false"
        ></BarTitleDialog>
        <v-card-text>
          <v-form
            ref="form"
            v-model="formValid"
          >
            <v-row>
              <v-col>
                <v-text-field
                  v-model="registerGuest.name"
                  outlined
                  label="Nome *"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="registerGuest.cpf"
                  v-mask="'###.###.###-##'"
                  outlined
                  label="CPF *"
                  :rules="[rules.cpf]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="registerGuest.email"
                  outlined
                  label="Email"
                  :rules="[optionalEmailRule]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="registerGuest.cell_phone"
                  v-mask="'(##)#####-####'"
                  outlined
                  label="Celular"
                  :rules="[optionalPhoneRule]"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="registerGuest.home_phone"
                  v-mask="'(##)####-####'"
                  class="ml-2"
                  outlined
                  label="Telefone Fixo"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                class="mr-2"
                color="secondary"
                x-large
                text
                @click="dialog = false"
              >
                Fechar
              </v-btn>
              <v-btn
                color="primary"
                :loading="loading"
                :disabled="loading"
                x-large
                @click="save()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import { validationRules, validateEmail, validatePhone } from '@/utils/validators'

export default {
  components: {
    BarTitleDialog,
  },
  props: {
    value: { type: Boolean },
  },
  data: () => ({
    dialog: false,
    registerGuest: {},
    formValid: true,
    rules: validationRules,

    loading: false,
  }),
  computed: {

  },
  watch: {
    value(val) {
      this.dialog = val
      if (val) {
        this.registerGuest = {}
        this.$nextTick(() => this.$refs.form?.resetValidation())
      }
    },
    dialog(val) {
      this.$emit('input', val)
    },
  },
  created() {
    this.registerGuest = {}
  },
  methods: {
    ...mapActions('guest', ['store']),
    ...mapMutations('reserve', ['addGuest']),
    optionalEmailRule(value) {
      return !value || validateEmail(value)
    },
    optionalPhoneRule(value) {
      return !value || validatePhone(value)
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$toast.error('Preencha os campos obrigatórios corretamente')

        return
      }
      this.loading = true
      this.store(this.registerGuest).then(response => {
        this.addGuest(response.data)
        this.$toast.success('Hóspede salvo com sucesso')
        this.dialog = false
      }).catch(error => {
        const errors = error.response?.data?.errors
        const firstError = errors ? Object.values(errors)[0][0] : null
        this.$toast.error(firstError || error.response?.data?.message || 'Erro ao salvar hóspede')
      }).finally(() => {
        this.loading = false
      })
    },

  },
}
</script>

<style scoped>

</style>
